// Claims keyed by id.
import {
  GET_ADMINISTRATION_CLAIMS,
  GET_ADMINISTRATION_CLAIM,
  CREATE_ADMINISTRATION_CLAIM,
  UPDATE_ADMINISTRATION_CLAIM,
  DESTROY_ADMINISTRATION_CLAIM,
  LINK_ADMINISTRATION_CLAIM_INVOICE,
  LINK_RETENTION_INVOICE,
  CREATE_ADMINISTRATION_CLAIM_INVOICE,
} from "./actions";

export function AdministrationClaimsReducer(state = {}, action) {
  switch (action.type) {
    case `${GET_ADMINISTRATION_CLAIMS}_FULFILLED`: {
      return _.mapKeys(action.payload.data, "id");
    }
    case `${GET_ADMINISTRATION_CLAIM}_FULFILLED`:
    case `${CREATE_ADMINISTRATION_CLAIM}_FULFILLED`:
    case `${UPDATE_ADMINISTRATION_CLAIM}_FULFILLED`:
    case `${LINK_ADMINISTRATION_CLAIM_INVOICE}_FULFILLED`:
    case `${LINK_RETENTION_INVOICE}_FULFILLED`:
    case `${CREATE_ADMINISTRATION_CLAIM_INVOICE}_FULFILLED`: {
      let newState = _.clone(state);
      const newItem = action.payload.data;
      const id = _.get(newItem, "id");
      newState[id] = newItem;
      return newState;
    }
    case `${DESTROY_ADMINISTRATION_CLAIM}_FULFILLED`: {
      const id = _.get(action.payload.data, "id");
      return _.omit(state, id);
    }
    default:
      return state;
  }
}
